<template>
    <div class="form-box">
        <el-form
            class="form__center"
            label-width="82px"
            size="small"
        >
            <el-form-item label="新邮箱：">
                <el-input
                    v-model="formItem.new_email"
                    placeholder="请输入新的邮箱"
                    style="width: 200px;margin-right: 30px"
                />
            </el-form-item>
            <el-form-item label="验证码：">
                <el-input
                    v-model="formItem.new_valicode"
                    placeholder="请输入新邮箱验证码"
                    style="width: 200px;margin-right: 30px"
                />
                <el-button
                    type="text"
                    :disabled="showCount"
                    @click="sendCaptcha"
                >
                    <span v-show="!showCount">{{ text }}</span>
                    <span v-show="showCount">{{ count }}秒后重新发送</span>
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-button
                    class="btn-standard"
                    type="primary"
                    @click="onSubmit"
                >
                    确认修改
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'

export default {
    name: 'Step2',
    inject: ['goPage'],
    data () {
        return {
            formItem: {
                new_email: '',
                new_valicode: ''
            },
            showCount: false,
            timer: null,
            count: 60,
            text: '发送验证码'
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.new_email': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入新的绑定邮箱'
            }, {
                test (val) {
                    return !(val && !(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(val)))
                },
                message: '请输入正确的邮箱'
            }
        ],
        'formItem.new_valicode': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入新手机验证码'
            },
            {
                test: /^\d{6}$/,
                message: '请输入6位数字验证码'
            }
        ]
    },
    methods: {
        sendCaptcha () {
            if (!(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(this.formItem.new_email))) {
                this.$message.error('请输入正确的邮箱')
                return false
            }
            this.$http.get('/api/user/sendemail', {
                params: {
                    email: this.formItem.new_email
                }
            }).then(res => {
                if (res) {
                    if (!this.timer) {
                        this.count = 60
                        this.showCount = true
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= 60) {
                                this.count--
                            } else {
                                this.showCount = false
                                clearInterval(this.timer)
                                this.timer = null
                                this.text = '重新发送'
                            }
                        }, 1000)
                    }
                }
            })
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/updatemail', qs.stringify({
                    step: 1,
                    new_email: this.formItem.new_email,
                    new_valicode: this.formItem.new_valicode
                })).then(res => {
                    if (res) {
                        this.$notify.success({
                            title: '通知',
                            message: `绑定邮箱修改成功。`
                        })
                        this.goPage('/index/info/safe')
                    }
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .form__center {
        width: 402px;
    }
</style>
